// src/lib/analyzerUmleitung.ts
// Baustein 6 (Umschalten): Die alten Analyzer-Seiten ohne dealId führen in den geführten
// Ablauf /check. Alle URL-Parameter bleiben erhalten (utm_*, gclid, fbclid und die
// Vorbelegung der Chrome-Erweiterung: kaufpreis, kaltmiete, flaeche, plz, adresse, hausgeld …).
import type { QuickCheckObjektart } from "./quickCheckDraft";

export function checkUmleitungsZiel(objektart: QuickCheckObjektart, search: string): string {
  const p = new URLSearchParams(search);
  p.delete("dealId");
  p.delete("objektart");
  const rest = p.toString();
  return `/check?objektart=${objektart}${rest ? `&${rest}` : ""}`;
}

export function hatDealId(search: string): boolean {
  return new URLSearchParams(search).get("dealId") != null;
}

/** Vorbelegung für /check aus den Parametern der Chrome-Erweiterung (gleiche Namen wie useUrlPrefill). */
export interface CheckVorbelegung {
  kaufpreis?: number;
  flaecheM2?: number;
  plz?: string;
  kaltmieteMonat?: number;
  hausgeldMonat?: number;
}

function zahl(v: string | null): number | undefined {
  if (!v) return undefined;
  const n = parseFloat(v.replace(",", "."));
  return Number.isFinite(n) && n > 0 ? n : undefined;
}

export function checkVorbelegungAusUrl(search: string): CheckVorbelegung {
  const p = new URLSearchParams(search);
  const plz = (p.get("plz") ?? "").trim();
  const v: CheckVorbelegung = {
    kaufpreis: zahl(p.get("kaufpreis")),
    flaecheM2: zahl(p.get("flaeche")),
    plz: /^\d{5}$/.test(plz) ? plz : undefined,
    kaltmieteMonat: zahl(p.get("kaltmiete")),
    hausgeldMonat: zahl(p.get("hausgeld")),
  };
  return Object.fromEntries(Object.entries(v).filter(([, x]) => x !== undefined)) as CheckVorbelegung;
}
